import { Injectable } from '@angular/core';
import {LogLevel} from './log-level.enum';
import {environment} from '../../environments/environment';

/**
 * localStorage key that turns debug/log output back on in a production build,
 * for diagnosing a live studio: localStorage.setItem('ami_debug_logs', '1')
 * then reload. Remove the key to go quiet again.
 */
const DEBUG_OVERRIDE_KEY = 'ami_debug_logs';

function debugOverrideEnabled(): boolean {
  try {
    return localStorage.getItem(DEBUG_OVERRIDE_KEY) === '1';
  } catch {
    return false;
  }
}

// Production builds keep warnings and errors (LogRocket records them) and
// drop the debug/info chatter, which otherwise dumps student and studio
// records into the console and into LogRocket session recordings.
const MIN_LEVEL: LogLevel = environment.production && !debugOverrideEnabled()
  ? LogLevel.WARN
  : LogLevel.DEBUG;

const noop = (..._args: any[]): void => {};

// Bound console functions rather than wrappers, so DevTools still reports the
// calling file:line instead of this file.
function writer(level: LogLevel, fn: (...args: any[]) => void): (...args: any[]) => void {
  return level >= MIN_LEVEL ? fn.bind(console) : noop;
}

@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  public static readonly debug = writer(LogLevel.DEBUG, console.debug);
  public static readonly log = writer(LogLevel.INFO, console.log);
  public static readonly warn = writer(LogLevel.WARN, console.warn);
  public static readonly error = writer(LogLevel.ERROR, console.error);
}
